import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

import { LibellesService } from './libelles.service';
import { SpinnerService } from './spinner.service';
import { ModalitesService } from './modalites.service';

@NgModule({
    imports: [HttpClientModule, SharedModule],
    declarations: [],
    exports: [],
    providers: [LibellesService,
         SpinnerService, ModalitesService]
})
export class CoreModule {}
